(function () {

    'use strict';

    angular.module('iplusjs.utils.konto', [
        'lodash',
        'iban',
        'iplusjs.config',
        'iplusjs.utils.misc',
        'iplusjs.utils.format'
    ])
    .service('KontoUtilsService', KontoUtilsService);

    KontoUtilsService.$inject = [
        '$log',
        'lodash',
        '$q',
        '$http',
        'FormatUtilsService',
        'MiscUtilsService',
        'AppConfig',
        'iban'
    ];
    function KontoUtilsService($log, _, $q, $http, FormatUtilsService, MiscUtilsService, AppConfig, Iban) {
        var that = this;

        that.regexIban = /^[a-zA-Z]{2}\d{2}\s?([0-9a-zA-Z]{4}\s?){4}[0-9a-zA-Z]{2}$/;

        that.checkIban = checkIban;
        that.checkIbanFormat = checkIbanFormat;
        that.isAuslaendischeIban = isAuslaendischeIban;
        that.existsIban = existsIban;
        function checkIban(iban, bic) {
            var checkedIbanResult;

            if (!iban) {
                return $q.reject('IBAN_LEER');
            }

            checkedIbanResult = checkIbanFormat(iban);

            if (!checkedIbanResult.valid) {
                return $q.reject(checkedIbanResult.message);
            }

            if (!isAuslaendischeIban(iban)) {
                bic = null;
            }

            return existsIban(Iban.electronicFormat(iban), bic).then(function (kontoverbindung) {
                return $q.resolve(kontoverbindung);
            });
        }
        function checkIbanFormat(iban) {
            var result = {
                message: 'OK',
                valid: true
            };

            if (!Iban.isValid(iban)) {
                return {
                    message: 'IBAN_FALSCHES_FORMAT',
                    valid: false
                };
            }

            if (!AppConfig.APP.auslaendischeIbanErlaubt && Iban.printFormat(iban).substr(0, 2) !== 'DE') {
                return {
                    message: 'IBAN_NICHT_DE',
                    valid: false
                };
            }

            return result;
        }
        function isAuslaendischeIban(iban) {
            if (MiscUtilsService.isEmpty(iban) || !Iban.isValid(iban)) {
                return false;
            }

            return Iban.printFormat(iban).substr(0, 2) !== 'DE';
        }
        function existsIban(iban, bic) {
            if (MiscUtilsService.isEmpty(iban)) {
                return $q.resolve();
            }

            var serviceUrl = FormatUtilsService.replace(AppConfig.API.services.kontoIban, iban);

            return $http.get(serviceUrl, {
                cache: true,
                params: {
                    bic: bic
                }
            }).then(function (response) {
                $log.debug('KontoUtilsService.existsIban SUCCESS');
                return response.data;
            }).catch(function (error) {
                $log.debug('KontoUtilsService.existsIban FAILURE');
                return $q.reject(error);
            });
        }

    }

})();
